// extracted by mini-css-extract-plugin
export var colorSquare = "_pq-0";
export var danger = "_pq-5";
export var lightPink = "_pq-8";
export var neutralBlue = "_pq-7";
export var neutralYellow = "_pq-6";
export var normal = "_pq-1";
export var primary = "_pq-2";
export var primaryLight = "_pq-3";
export var solidBlack = "_pq-g";
export var solidGreen = "_pq-b";
export var solidLightBlue = "_pq-d";
export var solidNavy = "_pq-c";
export var solidOrange = "_pq-f";
export var solidPink = "_pq-e";
export var solidRed = "_pq-9";
export var solidYellow = "_pq-a";
export var success = "_pq-4";